<template>
  <Breadcrumbs
      title="Edit Order Request"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Order Request History', path: '/order-request-history' },
      { label: 'Edit Order Request', path: '/edit-order-request' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
     <editOrderRequest/>
    </div>
  </div>
</template>

<script>


import editOrderRequest from "@/pages/stock/order_request/editOrderRequestForm.vue";
export default {
  name: 'indexList',
  components: {

    editOrderRequest,

  },


}

</script>
